<script setup lang="ts">
import { IDepartment } from '@/interfaces';
import BaseOverlay from '@/overlays/BaseOverlay.vue';

const emit = defineEmits(['close']);

interface Props {
  title: string;
  departments: IDepartment[];
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <BaseOverlay @close="emit('close')" :title="title">
    <template #content>
      <div
        v-for="(department, index) in departments"
        :key="index"
        class="flex items-center mb-6"
      >
        <div
          class="h-[88px] w-[88px] border-2 border-neutral-0 rounded-full flex items-center justify-center shadow-smallBold mr-6"
          :style="{ background: department.color }"
        >
          <fa-icon
            :icon="['fas', 'house-user']"
            class="text-neutral-0 text-3xl"
          />
        </div>

        <p class="h800">{{ department.name }}</p>
      </div>
    </template>
  </BaseOverlay>
</template>
